(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qt-gift-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qt-gift-guide')) {
    customElements.define(
      'qt-gift-guide',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => {
              const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
              if (!step) return;
              e.preventDefault();
              const next = (i + step + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            });
          });
        }

        select(index) {
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', String(on));
            /* Daniel 16-10: every price tab is reachable with Tab (arrows still switch) */
            const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
